import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import PersonMarriageNonResidentNotificationsShared from 'shell/components/shared/research-notifications/research-marriage-non-resident/edit-person';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface PersonMarriageNonResidentNotificationsCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const PersonMarriageNonResidentNotificationsCivilStatusShared = ({
  scope,
  items,
}: PersonMarriageNonResidentNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/matrimonio/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <PersonMarriageNonResidentNotificationsShared
        goBackUrl={redirectUrl}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

PersonMarriageNonResidentNotificationsCivilStatusShared.displayName =
  'Research Marriage Non Resident Notifications CivilStatusShared component';

export default PersonMarriageNonResidentNotificationsCivilStatusShared;
